import React from 'react';
import { Tabs, Spin } from 'antd';

import SectionTitle from '../../../components/shared/SectionTitle';
import BookCard from '../../../components/shared/BookCard';
import { useApi } from '../../../hooks/useApi';

import { Section, BooksGrid } from '../styles';

const TAB_CATEGORIES = [
  { key: 'ficcion', label: 'Ficción' },
  { key: 'no-ficcion', label: 'No Ficción' },
  { key: 'clasicos', label: 'Clásicos' },
];

function CategoryGrid({ categoryId }) {
  const { data: books, loading } = useApi(`/books/by-category/${categoryId}`);

  if (loading) {
    return <Spin size="large" style={{ display: 'block', margin: '40px auto' }} />;
  }

  return (
    <BooksGrid>
      {(books || []).map((book) => (
        <BookCard
          key={book.id}
          id={book.id}
          title={book.title}
          author={book.authorName}
          price={book.price}
          originalPrice={book.originalPrice}
          condition={book.condition}
          coverImage={book.coverImage}
          showAddToCart
        />
      ))}
    </BooksGrid>
  );
}

export default function BestSellers() {
  const items = TAB_CATEGORIES.map((cat) => ({
    key: cat.key,
    label: cat.label,
    children: <CategoryGrid categoryId={cat.key} />,
  }));

  return (
    <Section>
      <SectionTitle title="Más Vendidos" />
      <Tabs defaultActiveKey="ficcion" items={items} />
    </Section>
  );
}
